module.exports = __webpack_public_path__ + "img/6.bdb85395.jpg";